import { render, staticRenderFns } from "./StepIcon.vue?vue&type=template&id=35a30522&scoped=true"
import script from "./StepIcon.vue?vue&type=script&lang=js"
export * from "./StepIcon.vue?vue&type=script&lang=js"
import style0 from "./StepIcon.vue?vue&type=style&index=0&id=35a30522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a30522",
  null
  
)

export default component.exports